import React, { useContext } from 'react'

import DropdownMenu from 'components/CommonUI/Dropdown'
import SearchInput from 'components/CommonUI/SearchInput/SearchInput'
import { PanelContext, defaultFilterValue } from '../PanelsManagement'

const FILTER_ITEMS = [
  {
    id: 'connected',
    value: 1,
    label: 'Assigned',
  },
  {
    id: 'disconnected',
    value: 0,
    label: 'Unassigned',
  },
]

const FilterPage = () => {
  const { search, filter } = useContext(PanelContext)

  return (
    <div className="filter_page">
      <DropdownMenu
        classNameContainer="filter_page_select"
        defaultValueItem={defaultFilterValue}
        selectedValue={filter.value}
        handleSelectedClick={filter.onChange}
      >
        {FILTER_ITEMS.map((item) => (
          <DropdownMenu.Item key={item.id} itemData={item} />
        ))}
      </DropdownMenu>
      <SearchInput
        placeholder="Search panel by keyword"
        classNameContainer="filter_search_input"
        value={search.value}
        handleChange={search.onChange}
      />
    </div>
  )
}

export default FilterPage
